var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubspotRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_459_4363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "#FF7A59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0567 17.0882C16.0113 17.0882 15.1634 16.2496 15.1634 15.2149C15.1634 14.1802 16.0111 13.3413 17.0567 13.3413C18.1023 13.3413 18.9505 14.1799 18.9505 15.2149C18.9505 16.2498 18.1029 17.0882 17.0567 17.0882ZM17.6238 11.608V9.94001C17.8456 9.83845 18.0337 9.67566 18.1661 9.47081C18.2985 9.26595 18.3696 9.02755 18.3711 8.78364V8.74508C18.3711 8.04016 17.7881 7.46376 17.0764 7.46376H17.0373C16.3263 7.46376 15.7425 8.04044 15.7425 8.74508V8.78364C15.7441 9.02753 15.8153 9.26591 15.9476 9.47075C16.08 9.6756 16.2681 9.83839 16.4898 9.94001V11.608C15.8514 11.7043 15.2493 11.9663 14.7437 12.3679L10.1198 8.80852C10.1522 8.69143 10.1696 8.57069 10.1715 8.44922C10.1715 7.65051 9.51828 7.00219 8.71137 7.00001C7.90445 6.99782 7.24984 7.64504 7.24902 8.44403C7.2482 9.24301 7.90117 9.88997 8.70809 9.89133C8.96083 9.89024 9.20894 9.82343 9.42805 9.69747L13.9775 13.2002C13.5682 13.8098 13.3544 14.5297 13.3645 15.2639C13.3746 15.9981 13.6082 16.7118 14.0341 17.31L12.65 18.6799C12.4862 18.6286 12.3133 18.6133 12.1431 18.6353C11.9728 18.6572 11.8094 18.7158 11.664 18.807C11.5186 18.8982 11.3948 19.0198 11.3009 19.1635C11.207 19.3071 11.1454 19.4694 11.1203 19.6392C11.0953 19.809 11.1073 19.9822 11.1556 20.1469C11.2038 20.3116 11.2873 20.4638 11.4001 20.5931C11.5129 20.7225 11.6523 20.8258 11.8089 20.8961C11.9655 20.9663 12.1355 21.0018 12.3071 21C12.9699 21 13.5075 20.4679 13.5075 19.8119C13.5063 19.6966 13.4879 19.5821 13.4528 19.4723L14.82 18.1182C15.4636 18.6061 16.2491 18.8699 17.0567 18.8694C19.0968 18.8694 20.7497 17.2334 20.7497 15.2149C20.7497 13.3878 19.3929 11.879 17.6235 11.608",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_459_4363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspotRound);
export default __webpack_public_path__ + "static/media/HubspotRound.76f305717b43e65897d4eb0b168afc11.svg";
export { ForwardRef as ReactComponent };